import React from "react";
export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="31" viewBox="0 0 25 31">
    <g fill="none" fillRule="evenodd">
      <g stroke="currentColor" strokeWidth="1.5">
        <g>
          <g>
            <g>
              <path d="M13.884 2.718L7.145 26.949c-.148.532.164 1.084.696 1.232.332.092.688.007.942-.225l13.202-12.057c.337-.307.423-.804.209-1.207L15.73 2.517c-.259-.488-.864-.674-1.352-.415-.242.129-.421.351-.494.616z" transform="translate(-1149 -208) translate(607 162) translate(0 44) translate(542.095 2)"/>
              <path fill="#FFF" d="M7.67 2.415L.934 26.646c-.148.532.163 1.084.695 1.232.332.092.688.007.942-.225l13.202-12.057c.337-.307.423-.804.209-1.207L9.517 2.214c-.258-.488-.864-.674-1.352-.415-.242.129-.42.351-.494.616z" transform="translate(-1149 -208) translate(607 162) translate(0 44) translate(542.095 2)"/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
